<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">Booked Meeting Room List</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <!-- <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <mat-select  placeholder="Meeting Room" (selectionChange)="loadBookedMeetingRooms(0,perpage)" [(ngModel)]="meeting_room">
                            <mat-option [value]="mtroom.id" *ngFor="let mtroom of meetingRoomList">{{mtroom.room_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-4 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadBookedMeetingRooms(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <a routerLink="/add-meeting-room" class="ml-2 btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i> Book Meeting Room
                    </a>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Booking By</th>
                        <th>Meeting Room</th>
                        <th>Booking Date</th>
                        <th>From Time</th>
                        <th>To Time</th>
                        <th width="30%">Purpose</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let booked_room of booked_rooms;let index = index;">
                        <td>{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{booked_room.booked_by}}</td>
                        <td>{{booked_room.room_name}}</td>
                        <td>{{booked_room.start_on * 1000 | date}}</td>
                        <td>{{booked_room.start_on * 1000 | date:'shortTime'}}</td>
                        <td>{{booked_room.end_on * 1000 | date:'shortTime'}}</td>
                        <td>{{booked_room.purpose}}</td>
                        <td>
                            <div class="dropdown" *ngIf="(userId==booked_room.added_by || myrole == '1')">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{booked_room.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{booked_room.id}}">
                                    <a class="dropdown-item" routerLink="/update-meeting-room/{{booked_room.id}}" ><i class="fa fa-pen"></i> Update Booking</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !booked_rooms.length">
                        <td colspan="8" ><i class="far fa-frown"></i> No records not found</td>
                    </tr>
                </tbody>
            </table>

            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div> -->
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Choose a date</mat-label>
                            <input #dateRangeStart matInput readonly [matDatepicker]="picker" (dateChange)="getDatewiseData($event)">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()" style="cursor:pointer">clear</mat-icon>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="getbookingdata()"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
        
                    <a routerLink="/add-meeting-room" class="ml-2 btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i> Book Meeting Room
                    </a>
                </div>
            </div>

            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th colspan="8" class="text-center"><b>{{displayDate}}</b></th>
                    </tr>
                    <tr class="text-center">
                        <th>Timeslots</th>
                        <th>Meeting Room</th>
                        <th>Meeting Room 1</th>
                        <th>Meeting Room 2</th>
                        <th>Meeting Room 3</th>
                        <th>Meeting Room 4</th>
                        <th>Training Room</th>
                        <th *ngIf="myrole=='1' || myrole=='6'">Director's Meeting Room</th>
                    </tr>  
                    </thead>
                    <tbody *ngIf="loading">
                        <tr>
                            <td colspan="7" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="loaded"> 
                        <tr class="text-center" *ngFor="let number of [10,11,12,13,14,15,16,17,18,19,20];">
                            <td>{{number}}:00</td>
                            <td>
                                <span *ngIf="booking_data[1]" [innerHTML]="booking_data[1][number] | safe:'html'"></span>
                            </td>
                            <td>
                                <span *ngIf="booking_data[2]" [innerHTML]="booking_data[2][number] | safe:'html'"></span>
                            </td>
                            <td>
                                <span *ngIf="booking_data[3]" [innerHTML]="booking_data[3][number] | safe:'html'"></span>
                            </td>
                            <td>
                                <span *ngIf="booking_data[4]" [innerHTML]="booking_data[4][number] | safe:'html'"></span>
                            </td>
                            <td>
                                <span *ngIf="booking_data[5]" [innerHTML]="booking_data[5][number] | safe:'html'"></span>
                            </td>
                            <td>
                                <span *ngIf="booking_data[6]" [innerHTML]="booking_data[6][number] | safe:'html'"></span>
                            </td>
                            <td *ngIf="myrole=='1' || myrole=='6'">
                                <span *ngIf="booking_data[7]" [innerHTML]="booking_data[7][number] | safe:'html'"></span>
                            </td>
                        </tr>   
                    </tbody>   
                </table>
            </div>
        </div>
    </div>

   

    
</div>
    